import {add, div, divide100, formatDate, mul, multiply100, sub} from "@/libs/util";
const mixin =  {
  methods:{
    formatDate,
    multiply100,
    divide100,
    mul,
    div,
    add,
    sub,
  }
}
export const globalMixin = mixin
